export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation of an electronic check"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deposit account"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Number"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Series"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation code"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Check"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate"])}
}